<template>
  <div class="testPaperManageDetail" v-loading="loading">
    <div class="testPaperManageDetail01">
      <div style="padding-top: 20px">
        <div class="testPaperManageDetail-type">默认考卷</div>
      </div>
      <div
        class="testPaperManageDetail-box01"
        v-for="(item, index) in examList"
        :key="index"
      >
        <div class="testPaperManageDetail-index">{{ index + 1 }}</div>
        <div class="testPaperManageDetail-box02" @click="goExamMode(item)">
          {{ item.name }}
        </div>
      </div>
      <div v-if="examList.length == 0" class="testPaperManageDetail-none">
        暂无默认试卷，请前往考芽管理后台添加模拟考卷
      </div>
    </div>
    <div class="testPaperManageDetail02">
      <div style="padding-top: 20px">
        <div class="testPaperManageDetail-type">自定义考卷（最多10套）</div>
      </div>
      <div
        class="testPaperManageDetail-box01"
        v-for="(item, index) in examSettingList"
        :key="index"
        @mousemove="item.hoverTrue = true"
        @mouseleave="item.hoverTrue = false"
      >
        <div class="testPaperManageDetail-index">{{ index + 1 }}</div>
        <div class="testPaperManageDetail-box02" @click="goExamMode(item)">
          {{ item.name }}
          <div v-if="item.hoverTrue == true" class="testPaperManageDetail-hover">
            <i
              v-auth="'testPaperManageDetail_/examView'"
              class="iconfont icon-bianji testPaperManageDetail-icon"
              title="编辑"
              @click="goQuestion(item.id)"
            ></i>
            <i
              v-auth="'testPaperManageDetail_/exam/getExam'"
              class="testPaperManageDetail-icon el-icon-edit"
              @click="getExam(item.id)"
            ></i>
            <i
              v-auth="'testPaperManageDetail_/examSetting/deleteExam'"
              class="testPaperManageDetail-icon el-icon-delete"
              @click="deleteExam(item.id)"
            ></i>
          </div>
        </div>
      </div>
      <el-button
        type="primary"
        size="small"
        class="testPaperManageDetail-button"
        @click="addExam"
        v-auth="'testPaperManageDetail_/examSetting/addExamSetting'"
        >添加考卷</el-button
      >
    </div>

    <el-dialog
      title="添加试卷"
      :visible.sync="addFormVisible"
      width="25%"
      :close-on-click-modal="false"
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="rules"
      >
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="考试名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入考试名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属课程" prop="courseId">
              <el-cascader
                style="width:100%"
                clearable
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入具体课程"
                v-model="addForm.courseId"
                :options="subjectTreeList"
                @change="subjectChangess"
              ></el-cascader>
            </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="评分标准" prop="scoreRuleId">
              <el-select
                style="width: 100%"
                v-model="addForm.scoreRuleId"
                clearable
                placeholder="请输入评分标准"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addExamSetting">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑试卷" :visible.sync="editFormVisible" width="25%" left>
      <!-- <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >-->
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="rules"
      >
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="考试名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入考试名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属课程" prop="courseId">
              <el-cascader
                style="width:100%"
                clearable
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入具体课程"
                v-model="editForm.courseId"
                :options="subjectTreeList"
                @change="subjectChangess"
              ></el-cascader>
            </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="评分标准" prop="scoreRuleId">
              <el-select
                style="width: 100%"
                v-model="editForm.scoreRuleId"
                clearable
                disabled
                placeholder="请输入评分标准"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateExamSetting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      blockAddExamSetting: false,
      examList: [1],
      examSettingList: [],
      addForm: {
        courseId: JSON.parse(localStorage.getItem("jumpDetail")).courseId,
        scoreRuleId: "",
        type: "全真模考",
        name: "",
        sort: "",
      },
      editForm: {
        courseId: "",
        scoreRuleId: "",
        type: "",
        name: "",
        sort: "",
      },
      formLabelWidth: "80px",
      addFormVisible: false,
      editFormVisible: false,
      loading: true,
      subjectTreeList: [], //课程
      optionsType: [],
      examType: [],
      clickTrue: false,
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      rules: {
        courseId: [
          {
            required: true,
            message: "请输入所属课程",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属课程格式不正确",
          },
        ],
        scoreRuleId: [
          {
            required: true,
            message: "请输入评分标准",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "评分标准格式不正确",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入试卷类型",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "试卷类型长度在1到255个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "考试名称长度在1到255个字",
          },
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确",
          },
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确",
          },
        ],
        tryUse: [
          {
            required: true,
            message: "请输入是否试用",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否试用格式不正确",
          },
        ],
      },
    };
  },
  methods: {
    getExamList() {
      this.api.examSetting
        .getExamList({
          courseId: JSON.parse(localStorage.getItem("jumpDetail")).courseId,
          type: "全真模考",
        })
        .then((result) => {
          if (result.success) {
            this.examList = result.data;
            this.loading = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamSettingList() {
      this.api.examSetting
        .getExamList({
          courseId: JSON.parse(localStorage.getItem("jumpDetail")).courseId,
          agentId: JSON.parse(localStorage.getItem("user")).agentId,
          type: "全真模考",
        })
        .then((result) => {
          if (result.success) {
            for (let item of result.data) {
              item.hoverTrue = false;
            }
            this.examSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // goExamAchievement(item) {
    //   console.log("item",item)
    //   let obj = {
    //     examId : item.id,
    //     type : "exam"
    //   }
    //   localStorage.setItem("examAchievement", JSON.stringify(item));
    //   this.$router.push({ path: "/examAchievement" });
    // },
    goExamMode(item) {
      // console.log("item",item,this.clickTrue)
      if (this.clickTrue == false) {
        let obj = {
          id: item.id,
          type: "exam",
          names: item.name,
          dotime: item.time,
        };
        localStorage.setItem("jump", JSON.stringify(obj));
        this.$router.push({
          path: "/previewExamination",
          query: {
            id: item.id,
            names: item.name,
            dotime: 90,
            type: "exam",
          },
        });
      }
    },
    getExamTypeList() {
      this.api.examType
        .getExamTypeList({ type: "考试" })
        .then((result) => {
          this.examType = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取评分标准
    getScoreRuleSelectListByCourse() {
      this.api.scoreRule
        .getScoreRuleSelectListByCourse({
          courseId: JSON.parse(localStorage.getItem("jumpDetail")).courseId,
        })
        .then((result) => {
          this.optionsType = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addExam() {
      this.addFormVisible = true;
      this.getSubjectTreeList();
      this.getExamTypeList();
      this.getScoreRuleSelectListByCourse();
    },
    updateExam() {
      this.getSubjectTreeList();
      this.getExamTypeList();
      this.getScoreRuleSelectListByCourse();
      this.editFormVisible = true;
    },
    goQuestion(id) {
      this.clickTrue = true;
      this.$router.push({
        path: "/examView",
        query: {
          examId: id,
        },
      });
    },
    getExam(id) {
      this.clickTrue = true;
      this.api.examSetting
        .getExam({ id: id })
        .then((result) => {
          this.editForm = result.data;
          this.clickTrue = false;
          this.updateExam();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addExamSetting() {
      if (this.blockAddExamSetting) {
        return false;
      }
      this.blockAddExamSetting = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.examSetting
            .addExam(this.addForm)
            .then((result) => {
              this.getExamSettingList();
              this.addFormVisible = false;
              this.blockAddExamSetting = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateExamSetting() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.examSetting
            .updateExam(this.editForm)
            .then((result) => {
              this.getExamSettingList();
              this.editFormVisible = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteExam(id) {
      this.clickTrue = true;
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.examSetting
            .deleteExam([{ id: id }])
            .then((result) => {
              if (result.success) {
                this.getExamSettingList();
                this.clickTrue = false;
                this.$message.success(result.message);
              } else {
                this.clickTrue = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
  },
  watch: {},
  mounted() {
    this.getExamList();
    this.getExamSettingList();
  },
};
</script>
<style scoped>
.testPaperManageDetail {
  font-size: 13px;
  background-color: #fff;
  display: flex;
  min-height: calc(100% - 20px);
}
.testPaperManageDetail01 {
  padding-left: 20px;
  margin-right: 20px;
  padding-bottom: 40px;
  width: 48%;
}
.testPaperManageDetail02 {
  padding-left: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  min-height: calc(100% - 40px);
  width: 48%;
}
.testPaperManageDetail-type {
  border-left: 4px solid rgb(77, 148, 255);
  padding-left: 10px;
  font-size: 14px;
  font-weight: 600;
}
.testPaperManageDetail-none {
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 45%;
}
.testPaperManageDetail-box01 {
  display: flex;
  flex-wrap: wrap;
}
.testPaperManageDetail-box02 {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  height: 30px;
  width: 90%;
  font-size: 13px;
  margin-top: 20px;
  line-height: 32px;
  text-align: center;
}
.testPaperManageDetail-hover {
  position: absolute;
  top: 0px;
  right: 0px;
}
.testPaperManageDetail-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.testPaperManageDetail-box02:hover {
  color: rgb(77, 148, 255);
}
.testPaperManageDetail-index {
  line-height: 32px;
  margin-right: 20px;
  margin-top: 20px;
}
.testPaperManageDetail-button {
  width: 90%;
  margin-left: 27px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/fullTruthModelTest/testPaperManageDetail.vue